<template>
  <div>
    <label
      class="block mb-2 text-sm font-medium text-slate-700 dark:text-slate-300"
    >
      {{ label }}
    </label>

    <div class="relative">
      <input
        :type="computedType"
        :placeholder="placeholder"
        :inputmode="inputmode"
        class="w-full px-3 bg-white border rounded-lg h-11 dark:bg-slate-900 focus:outline-none focus:ring-2 border-primary/30 focus:ring-primary/40 text-slate-800 dark:text-slate-100 placeholder-slate-400"
        :class="type === 'password' ? 'pe-10' : ''"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />

      <!-- Eye toggle (only for password) -->
      <button
        v-if="type === 'password'"
        type="button"
        class="absolute inset-y-0 flex items-center text-slate-500 dark:text-slate-300 hover:text-primary"
        :class="eyePositionClass"
        @click="togglePassword"
        aria-label="Toggle password visibility"
      >
        <!-- show icon -->
        <svg
          v-if="showPassword"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>

        <!-- hide icon -->
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-6.5 0-10-8-10-8a21.77 21.77 0 0 1 5.06-6.94"></path>
          <path d="M1 1l22 22"></path>
          <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 8 10 8a21.82 21.82 0 0 1-4.12 5.08"></path>
          <path d="M14.12 14.12a3 3 0 0 1-4.24-4.24"></path>
        </svg>
      </button>
    </div>

    <p v-if="error" class="mt-1 text-xs text-red-600">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    modelValue: [String, Number],
    label: String,
    type: { type: String, default: "text" },
    placeholder: String,
    error: String,
    inputmode: String,
  },
  emits: ["update:modelValue"],

  data() {
    return {
      showPassword: false,
    };
  },

  computed: {
    computedType() {
      if (this.type !== "password") return this.type;
      return this.showPassword ? "text" : "password";
    },

    // RTL/LTR friendly eye placement
    eyePositionClass() {
      // if parent sets dir="rtl" on html/body, Tailwind supports logical classes:
      // use "end-3" to auto switch in rtl/ltr
      return "end-3";
    },
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
